import module from 'catalogo/module.js'

const schema = {
  id: 'number',
  id_tipo_concepto: 'number',
  impuesto_estatal: 'boolean',
  editable: 'boolean',
  orden: 'number',
  pagoExterno: 'boolean',
  porcentaje_excento: 'number',
  porcentaje_plan_de_pension: 'number',
}

class CatalogoFiniquitoConceptosService {
  constructor ($http) {
    this.$http = $http
  }

  get (config = {}) {
    return this.$http.get('/api/catalogo/finiquito_conceptos', {
      params: {
        id_proyecto: config.id_proyecto,
      },
      cache: 'catalogo',
      schema,
    })
  }
}

module.service('CatalogoFiniquitoConceptos', CatalogoFiniquitoConceptosService)



// WEBPACK FOOTER //
// ./src/catalogo/services/Catalogo/FiniquitoConceptos.js